import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_website_review_vote_hdr_RowClass} from '../../../dbschema';

export class WebsiteReviewVoteContainerModel extends BaseContainerModel {
  bl_cms_website_review_vote_hdr: bl_cms_website_review_vote_hdr_RowClass = new bl_cms_website_review_vote_hdr_RowClass();
}
